const routes = [
  {
    path:'/unauthorized',
    name:'unauthorized',
  },
  {
    path: '/',
    name: 'Início',
    component: () => import(`@/pages/Home.vue`),
  },
  {
    path: '/client',
    name: 'Cliente',
    meta: {
      access: 'client',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Person.vue`),
  },
  {
    path: '/office',
    name: 'Servico',
    meta: {
      access: 'office',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Officce.vue`),
  },
  {
    path: '/grupo',
    name: 'Grupo',
    meta: {
      access: 'group',
      requiresAuth: true,
    },

    component: () => import(`@/pages/Group.vue`),
  },
  {
    path: '/user',
    name: 'Usuário',
    meta: {
      access: 'user',
      requiresAuth: true,
    },

    component: () => import(`@/pages/User.vue`),
  },
  {
    path: '/company',
    name: 'Empresa',
    meta: {
      access: 'company',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Company.vue`),
  },
  {
    path: '/additional_work',
    name: 'Adicional de Trabalho',
    meta: {
      access: 'additional_work',
      requiresAuth: true,
    },
    component: () => import(`@/pages/AdditionalWork.vue`),
  },
  {
    path: '/convention',
    name: 'Convenção Coletiva',
    meta: {
      access: 'convention',
      requiresAuth: true,
    },
    component: () => import(`@/pages/CollectiveConvention.vue`),
  },
  {
    path: '/budget',
    name: 'Orçamento',
    meta: {
      access: 'budget',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Budget.vue`),
  },
  {
    path: '/city',
    name: 'Cidade',
    meta: {
      access: 'city',
      requiresAuth: true,
    },
    component: () => import(`@/pages/City.vue`),
  },
  {
    path: '/category',
    name: 'Categoria de Produtos',
    meta: {
      access: 'category',
      requiresAuth: true,
    },
    component: () => import(`@/pages/ProductCategory.vue`),
  },
  {
    path: '/product',
    meta: {
      access: 'product',
      requiresAuth: true,
    },
    name: 'Produtos',
    component: () => import(`@/pages/Product.vue`),
  },
  {
    path: '/contract',
    name: 'Contratos',
    meta: {
      access: 'contract',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Contract.vue`),
  },
  {
    path: '/requests',
    name: 'Requisições',
    meta: {
      access: 'requests',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Request.vue`),
  },
  {
    path: '/initialapproval',
    name: 'Contrato Inicial',
    meta: {
      access: 'initialapproval',
      requiresAuth: true,
    },
    component: () => import(`@/pages/InitialContract.vue`),
  },
  {
    path: '/stock',
    name: 'Estoque',
    meta: {
      access: 'stock',
      requiresAuth: true,
    },
    component: () => import(`@/pages/Stock.vue`),
  },
]

export default routes



// WEBPACK FOOTER //
// ./src/router/routes.js